export default __webpack_public_path__ + "static/media/saly.00f7c7c0.png";